const e=async(e,t,n,r,i,a)=>{let{data:o}=await e.get(`/webhooks/${t}/${n}/${r}/events/${i}/attempts`,{params:a});return o};export{e as getWebhookAttempts};
//# sourceMappingURL=get-webhook-attempts.mjs.map